<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >新增</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新增"
      width="35%"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" label-width="100px">
        <el-form-item label="平台：" prop="platform">
          <el-select v-model="detail.platform" placeholder="请选择">
            <el-option
              v-for="item in platformType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户：" prop="tenantId">
          <el-select v-model="detail.tenantId">
            <el-option
              v-for="item in tentIdlist"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本：" prop="version">
          <el-input v-model="detail.version"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <el-input
            v-model="detail.content"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="下载地址：" prop="lineUrl">
          <el-input v-model="detail.lineUrl"></el-input>
        </el-form-item>

        <el-form-item
          label="uploadUrl："
          prop="uploadUrl"
          v-if="detail.platform"
        >
          <el-input v-model="detail.uploadUrl" disabled></el-input>
          <upload
            :platform="detail.platform"
            list-type="text"
            class="upload"
            :drag="false"
            :value="detail.uploadUrl"
            :data="{
              category: detail.platform,
              isKeepName: true,
              type: 1,
              tenantId: detail.tenantId,
            }"
            @uploaded="(url) => saveAppInfo(detail.platform, url)"
          >
            <a slot="content" class="edit-button">
              <i class="el-icon-edit"></i>
            </a>
          </upload>
        </el-form-item>

        <el-form-item label="状态:" prop="status">
          <el-switch active-color="#13ce66" v-model="detail.status">
          </el-switch>
        </el-form-item>
        <el-form-item label="是否强制升级:" prop="isForce">
          <el-switch active-color="#13ce66" v-model="detail.isForce">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('form')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Upload from "components/upload";
export default {
  name: "AppCreate",
  data() {
    return {
      dialogVisible: false,
      activeName: "first",
      detail: {
        platform: "",
        uploadUrl: "",
      },
      platformType: [
        {
          value: "android",
          label: "android",
        },
        {
          value: "ios_testflight",
          label: "ios_testflight",
        },
        {
          value: "ios_appstore",
          label: "ios_appstore",
        },
        {
          value: "google",
          label: "google",
        },
      ],
      userType: "1",
      lists: [
        { label: "用户账号", value: "1" },
        { label: "用户ID", value: "2" },
      ],
      coinTypes: ["USDT", "SHIB", "BABYDOGE", "ETH"],
      rules: {
        userId: {
          required: true,
          message: "请填写转入的用户账号",
          trigger: "blur",
        },
        coin: {
          required: true,
          message: "请选择币种",
          trigger: "blur",
        },
        amount: {
          required: true,
          message: "请输入转账金额",
          trigger: "blur",
        },
      },
    };
  },
  components: { Upload },
  watch: {
    activeName: {
      handler(val, oldVal) {
        if (val != oldVal) {
          this.detail = {};
          this.$refs["form"].resetFields();
        }
      },
    },
  },
  computed: {
    ...mapState("app", [
      "transferTypeData",
      "androidInfo",
      "iosInfo",
      "tentIdlist",
    ]),
    ...mapState("ctf", ["coinList"]),
  },
  mounted() {
    this.listAllCoin();
    this.getTransferType();
  },
  methods: {
    ...mapActions("app", [
      "create",
      "transfer",
      "mockTransfer",
      "reqList",
      "getTransferType",
      "saveInfo",
      "addApp",
      "info",
      "pagination",
    ]),
    ...mapActions("ctf", ["getCtflist", "listAllCoin"]),
    saveAppInfo(platform, url) {
      console.log("url", url);
      this.$nextTick(() => {
        this.detail.uploadUrl = url;
      });
      // this.saveInfo({ platform, url }).then((res) => {
      //   this.$message({
      //     message: '上传成功！',
      //     type: 'success'
      //   });

      //   // this.info(this.detail.platform);
      //   // this.info('plist');
      // });
    },
    handleClick(tab, event) {
      console.log(tab.name, event);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.activeName = "first";
      this.$refs["form"].resetFields();
    },
    close() {
      this.dialogVisible = false;
      this.detail = {};
      this.activeName = "first";
      this.$refs["form"].resetFields();
    },
    handleSave() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.addApp({
            ...this.detail,
            status: this.detail.status == true ? 1 : 0,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "新增成功！",
                type: "success",
              });
              this.$emit("refresh", this.pagination);
              this.dialogVisible = false;
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
